module.exports = __webpack_public_path__ + "static/NightInTheWoods3-849bfe39253e73bfca420f0139fc5248.webp";